var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.debug)?_c('div',[_c('json-viewer',{attrs:{"value":_vm.session}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }